module.exports = __webpack_public_path__ + "img/icon-house.257065d6.svg";